import { render, staticRenderFns } from "./StockHoldingsPanel.vue?vue&type=template&id=dafd9d58&scoped=true&"
import script from "./StockHoldingsPanel.vue?vue&type=script&lang=js&"
export * from "./StockHoldingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StockHoldingsPanel.vue?vue&type=style&index=0&id=dafd9d58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafd9d58",
  null
  
)

export default component.exports